import React from 'react';

const SalesAndCommissionsPage = React.lazy(() => import('pages/sales-commissions/details'));
const SalesAndCommissionsDashboardPage = React.lazy(() => import('pages/sales-commissions/dashboard'));

const policies = [{ resource: 'salesAndCommissions', action: 'view' }];
const policiesDashboard = [{ resource: 'salesAndCommissionsDashboard', action: 'view' }];

export const definitions = [
  {
    index: true,
    policies: policies,
    component: <SalesAndCommissionsPage />
  },
  {
    path: ':partnerID',
    policies: policies,
    component: <SalesAndCommissionsPage />
  },
  {
    path: 'dashboard',
    policies: policiesDashboard,
    component: <SalesAndCommissionsDashboardPage />
  }
];
